import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const OppositeArrowsGlyph = /*#__PURE__*/createElement("g", {
  id: "opposite_arrows",
  fill: "none",
  style: {
    transform: 'scale(3) translate(2px, 2px)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M11.9014 6.45089L6.45048 1M6.45048 1L0.999593 6.45089M6.45048 1L6.45048 17.7137",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M12.6299 12.7464L18.0808 18.1973M18.0808 18.1973L23.5317 12.7464M18.0808 18.1973L18.0808 1.48353",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const OppositeArrows = createSvg({
  name: 'opposite_arrows',
  path: OppositeArrowsGlyph
});

export default OppositeArrows;
export { OppositeArrowsGlyph };
